import React from 'react'
import ReactDOM from 'react-dom'
import './theme/index.scss'
import './index.css'
import App from './App'
import { BrowserRouter } from 'react-router-dom'
import reportWebVitals from './reportWebVitals'
import { SystemMessageProvider } from './context/SystemMessageContext'
import { PageListProvider } from './context/AuthContext'
ReactDOM.render(
    <BrowserRouter>
        <SystemMessageProvider>
            <PageListProvider>
                <App />
            </PageListProvider>
        </SystemMessageProvider>
    </BrowserRouter>,
    document.getElementById('root')
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
